import { EncounterStartType } from "@/api/generated/models";

export const GENERAL_EVENTS = {
  visitedSplashScreen: "superclinical-__visited-landing-page",
  visitedSplashScreenWithCuraiUtm:
    "superclinical-__visited-landing-page-with-curai-utm",
} as const;

export const WALMART_EVENTS = {
  visitedSplashScreen: "superclinical-__visited_walmart_splash_screen",
  visitedGlp1SplashScreen: "superclinical-__visited_walmart_glp1_splash_screen",
} as const;

export const SAMS_CLUB_EVENTS = {
  visitedSplashScreen: "superclinical-__visited_sams_club_splash_screen",
  visitedGlp1SplashScreen:
    "superclinical-__visited_sams_club_glp1_splash_screen",
} as const;

export const WORKWHILE_EVENTS = {
  visitedSplashScreen: "superclinical-__visited_workwhile_splash_screen",
} as const;

/** DO NOT rename or remove these without updating Google Ads click events in Segment */
export const AD_CONVERSION_EVENTS = {
  conversationCreated: "superclinical-__conversation-created",
  fifthMessageSent: "superclinical-__fifth-message-sent",
  startAVisit: "superclinical-__clicked-start-a-visit", // start of user progression
  outgoingDocumentSent: "superclinical-__outgoing-document-sent",
  checkoutCanceled: "superclinical-__checkout-canceled",

  // FE/BE events that fire from both for redundancy
  paywallPresented: "paywall_presented",
  checkoutStarted: "checkout_started",
  checkoutStartedAll: "checkout_started_all",
  paymentCompleted: "payment_completed",
  paymentCompletedAll: "payment_completed_all",
  visitStarted: "visit_started",

  // Deprecated - still used by Segment mapping to Google Ad campaigns, only safe to remove once fully migrated
  deprecatedPaymentSuccess: "superclinical-__payment-success",
  deprecatedClinicVisitStarted: "superclinical-__clinic-visit-started",
  deprecatedCheckoutStarted: "superclinical-__checkout-started",
} as const;

// Deprecated - still used by Segment mapping to Google Ad campaigns, only safe to remove once fully migrated
export const DEPRECATED_ASYNC_REQUEST_SENT_EVENTS: Partial<
  Record<EncounterStartType, string>
> = {
  [EncounterStartType.ASYNC_RX]: "superclinical-__async-rx-request-sent",
  [EncounterStartType.ASYNC_DX]: "superclinical-__async-dx-request-sent",
  [EncounterStartType.RX_RENEWAL]: "superclinical-__rx-renewal-request-sent",
};
